import { StyleSheet } from 'react-native';

export const styles = StyleSheet.create({
  buttonGroup: {
    flexDirection: 'row',
    flex: 1,
    gap: 8,
    width: '100%',
  },
  container: {
    alignItems: 'center',
    backgroundColor: '#FFF',
    borderColor: '#8F8F8F',
    borderRadius: 6,
    borderWidth: 1,
    flexGrow: 1,
    flexShrink: 1,
    height: 76,
    justifyContent: 'center',
    padding: 4,
    width: 76,
  },
  snackbar: {
    alignSelf: 'flex-end',
    width: 200,
    zIndex: 1000,
    marginRight: 16,
    backgroundColor: 'white',
  },
  snackbarText: {
    backgroundColor: 'white',
  },
});
